import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import AuthModal from '../../components/Auth/AuthModal';
import styles from './Header.module.css';

const logo = '/Logo.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleTryNowClick = (e) => {
    e.preventDefault();
    if (currentUser) {
      navigate('/app');
    } else {
      setIsAuthModalOpen(true);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const handleNavClick = (e) => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <nav className={styles.nav}>
        <Link to="/" className={styles.logoContainer} onClick={handleNavClick}>
          <motion.img 
            src={logo}
            alt="ReverbBeat" 
            className={styles.logo}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
          />
          <motion.span 
            className={styles.beta}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: 0.2 }}
          >
            BETA
          </motion.span>
        </Link>
        <div className={styles.navLinks}>
          <Link to="/" className={styles.navLink} onClick={handleNavClick}>Home</Link>
          {!currentUser && <Link to="/about" className={styles.navLink} onClick={handleNavClick}>About</Link>}
          <Link to="/documentation" className={styles.navLink} onClick={handleNavClick}>Docs</Link>
          <Link to="/pricing" className={styles.navLink} onClick={handleNavClick}>Pricing</Link>
          {!currentUser && <Link to="/affiliate/login" className={styles.navLink} onClick={handleNavClick}>Become Partner</Link>}
          {currentUser && (
            <Link to="/settings" className={styles.navLink} onClick={handleNavClick}>Settings</Link>
          )}
          {!currentUser && (
            <a href="#" onClick={handleTryNowClick} className={styles.navButton}>
              Try Now →
            </a>
          )}
          {currentUser && (
            <button onClick={handleLogout} className={`${styles.navButton} ${styles.logoutButton}`}>
              Logout
            </button>
          )}
        </div>
        <button className={styles.menuButton} onClick={toggleMenu}>
          {isMenuOpen ? (
            <svg className={styles.closeIcon} viewBox="0 0 24 24" width="24" height="24">
              <path
                fill="currentColor"
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              />
            </svg>
          ) : (
            <div className={`${styles.menuBar} ${isMenuOpen ? styles.menuOpen : ''}`} />
          )}
        </button>
      </nav>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            className={styles.mobileMenu}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <button className={styles.mobileCloseButton} onClick={toggleMenu}>
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path
                  fill="currentColor"
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                />
              </svg>
            </button>
            <Link to="/" onClick={(e) => { toggleMenu(); handleNavClick(e); }}>Home</Link>
            {!currentUser && <Link to="/about" onClick={(e) => { toggleMenu(); handleNavClick(e); }}>About</Link>}
            <Link to="/documentation" onClick={(e) => { toggleMenu(); handleNavClick(e); }}>Docs</Link>
            <Link to="/pricing" onClick={(e) => { toggleMenu(); handleNavClick(e); }}>Pricing</Link>
            {!currentUser && <Link to="/affiliate/login" onClick={(e) => { toggleMenu(); handleNavClick(e); }}>Become Partner</Link>}
            {currentUser && (
              <Link to="/settings" onClick={(e) => { toggleMenu(); handleNavClick(e); }}>Settings</Link>
            )}
            {!currentUser && (
              <a href="#" onClick={(e) => { toggleMenu(); handleTryNowClick(e); }} className={styles.mobileNavButton}>
                Try Now →
              </a>
            )}
            {currentUser && (
              <button onClick={(e) => { toggleMenu(); handleLogout(e); }} className={styles.mobileNavButton}>
                Logout
              </button>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      <AuthModal 
        isOpen={isAuthModalOpen} 
        onClose={() => setIsAuthModalOpen(false)} 
      />
    </>
  );
};

export default Header;
